module.exports = __webpack_public_path__ + "img/deafinition-bg.cc2d5c2c.jpg";